import { Component, Input, OnInit } from '@angular/core';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';

@Component({
  selector: 'appStatus',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent {
  constructor(private widgetsService_:WidgetsService){
    this.widgetsService_.layoutRoot$.subscribe(form =>{
        this.statusId = form.version?.StatusId;
    })
  }
  @Input() statusId?: number;
  getStatus(statusId): string {
    switch(statusId) {
      case 1: return('Draft');
      case 2: return('Pending Approval');
      case 3: return('Rejected');
      case 4: return('Approved');
      case 5: return('Published');
      default: return('Unknown');
    }
  }

  getClass(statusId): string {
    switch(statusId) {
      case 1: return('status-draft');
      case 2: return('status-pendingapproval');
      case 3: return('status-rejected');
      case 4: return('status-approved');
      case 5: return('status-published');
      default: return('status-base');
    }
  }
}
